/* Import Estilo */
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/* Import Bibliotecas */
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

/* Import Componentes */
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import BtnVoltar from '../../../../components/bntVoltar';
import MenuLateral from '../../../../components/MenuLateral';
import { validadorCPF, validadorCNPJ, validadorEmail, validadorNomeCompleto, validadorNumeroCelular, validadorDataNascimento, removerCaracteresEspeciais, converterDataParaYMD, formatadorCPF, formatadorCNPJ, mascaraCelular, mascaraTelefone } from '../../../../utils/Validadores/index.js';

/* Import Requisição API */
import api from '../../../../api';

export default function CadastroClientes() {
    const [usuario_id, setIdUsuario] = useState();
    const [nome, setNome] = useState('');
    const [razaoSocial, setRazaoSocial] = useState('');
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [inscricaoEstadual, setInscricaoEstadual] = useState('');
    const [inscricaoMunicipal, setInscricaoMunicipal] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [telefone, setTelefone] = useState('');
    const [dataNascimento, setDataNascimento] = useState('');
    const [dataNascimentoValido, setDataNascimentoValido] = useState(null);
    const [sexo, setSexo] = useState('');
    const [tipoCliente, setTipoCliente] = useState('Atacadista');
    const [statusCliente, setStatusCliente] = useState('Ativo');
    const [isCNPJ, setIsCNPJ] = useState(false);

    const [cep, setCep] = useState('');
    const [logradouro, setLogradouro] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidade, setCidade] = useState('');
    const [estado, setEstado] = useState('');

    const [texto, setTexto] = useState('');
    const navigate = useNavigate();

    const [modalAberto, setModalAberto] = useState(false);
    const caixaDeDialogo = useRef(null);

    /* Variáveis auxiliares */
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById('CaixaDeDialogo');
    }, []);

    const fecharModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.close();
        }
    };

    const mostrarModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                if (response.data.success) {
                    setIdUsuario(response.data.user.id);
                } else {
                    console.error('Erro na resposta:', response.data);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };
        buscarDadosUsuario();
    }, []);

    const buscarEnderecoPorCep = async (cep) => {
        if (cep.length !== 8) {
            setTexto('Por favor, insira um CEP válido com 8 dígitos.');
            mostrarModal();
            return;
        }
        try {
            const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
            const data = await response.json();
            if (data.erro) {
                setTexto('CEP não encontrado.');
                mostrarModal();
            } else {
                setLogradouro(data.logradouro || '');
                setBairro(data.bairro || '');
                setCidade(data.localidade || '');
                setEstado(data.uf || '');
            }
        } catch (error) {
            console.error('Erro ao buscar endereço:', error);
            setTexto('Erro ao buscar o endereço. Tente novamente mais tarde.');
            mostrarModal();
        }
    };

    const mascaraCep = (valor) => {
        return valor
            .replace(/\D/g, '')
            .replace(/(\d{5})(\d{3})/, '$1-$2')
            .slice(0, 9);
    };

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                if (response.data.success) {
                    setIdUsuario(response.data.user.id);
                } else {
                    console.error('Erro na resposta:', response.data);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };
        buscarDadosUsuario();
    }, []);

    const enviarCadastroCliente = async (event) => {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });

        const cpfCnpjLimpo = removerCaracteresEspeciais(cpfCnpj);
        const celularLimpo = removerCaracteresEspeciais(celular);
        const emailValido = validadorEmail(email);
        const nomeValido = validadorNomeCompleto(nome);
        const celularValido = validadorNumeroCelular(celularLimpo);
        const dataValida = validadorDataNascimento(dataNascimento);
        const cpfOuCnpjValido = cpfCnpjLimpo.length === 11 ? validadorCPF(cpfCnpjLimpo) : validadorCNPJ(cpfCnpjLimpo);

        if (!cpfOuCnpjValido) {
            setTexto("CPF ou CNPJ inválido.");
            mostrarModal();
            return;
        }

        if (!emailValido) {
            setTexto("E-mail inválido.");
            mostrarModal();
            return;
        }

        if (!nomeValido) {
            setTexto("Informe o nome completo.");
            mostrarModal();
            return;
        }

        if (!celularValido) {
            setTexto("Número de celular inválido.");
            mostrarModal();
            return;
        }

        if (!dataValida) {
            setTexto("Data de nascimento inválida ou menor de 18 anos.");
            mostrarModal();
            return;
        }

        // Validar IE quando for CNPJ
        if (cpfCnpjLimpo.length === 14 && !inscricaoEstadual) {
            setTexto("Inscrição Estadual é obrigatória para CNPJ.");
            mostrarModal();
            return;
        }

        const cliente = {
            nome,
            razao_social: razaoSocial || nome,
            cpf_cnpj: cpfCnpjLimpo,
            inscricao_estadual: inscricaoEstadual || null,
            inscricao_municipal: inscricaoMunicipal || null,
            email,
            celular: removerCaracteresEspeciais(celular),
            telefone: telefone ? removerCaracteresEspeciais(telefone) : null,
            data_nascimento: converterDataParaYMD(dataNascimento),
            sexo,
            nivel_acesso: tipoCliente,
            status_cliente: statusCliente,
        };

        const endereco = {
            cep: removerCaracteresEspeciais(cep),
            logradouro,
            numero,
            complemento,
            bairro,
            cidade,
            estado,
        };

        setLoading(true);
        try {
            const response = await api.post('/clientes', {
                cliente,
                endereco
            });

            if (response.data.success) {
                navigate('/menu/clientes');
            } else {
                // Tratar mensagens de erro do backend
                if (response.data.errors && response.data.errors.length > 0) {
                    // Se houver array de erros, mostrar todos
                    const mensagensErro = response.data.errors.join('\n');
                    setTexto(mensagensErro);
                } else {
                    // Senão, mostrar a mensagem principal
                    setTexto(response.data.message || "Erro ao cadastrar cliente.");
                }
                mostrarModal();
            }
        } catch (error) {
            console.error("Erro no cadastro:", error);
            console.error("Detalhes do erro:", error.response?.data);
            
            // Melhorar tratamento de erros
            if (error.response?.data) {
                const errorData = error.response.data;
                
                // Se houver array de erros de validação
                if (errorData.errors && errorData.errors.length > 0) {
                    const mensagensErro = errorData.errors.join('\n');
                    setTexto(mensagensErro);
                } 
                // Se houver mensagem específica (ex: CPF/CNPJ ou email duplicado)
                else if (errorData.message) {
                    setTexto(errorData.message);
                } 
                // Erro genérico
                else {
                    setTexto("Erro ao processar solicitação.");
                }
            } 
            // Erro de conexão
            else if (error.request) {
                setTexto("Erro de conexão com o servidor. Verifique sua internet.");
            } 
            // Outro erro
            else {
                setTexto("Erro ao enviar solicitação: " + error.message);
            }
            
            mostrarModal();
        } finally {
            setLoading(false);
        }
    };

    const handleDataNascimentoChange = (e) => {
        let valor = e.target.value.replace(/\D/g, '');
        if (valor.length > 2 && valor.length <= 4) {
            valor = `${valor.slice(0, 2)}/${valor.slice(2)}`;
        } else if (valor.length > 4) {
            valor = `${valor.slice(0, 2)}/${valor.slice(2, 4)}/${valor.slice(4, 8)}`;
        }
        setDataNascimento(valor);
        if (valor.length === 10) {
            setDataNascimentoValido(validadorDataNascimento(valor));
        }
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === 'e') {
                e.preventDefault();
                setNome('Cliente Exemplo LTDA');
                setRazaoSocial('Cliente Exemplo Comércio LTDA');
                setCpfCnpj('62713927000126');
                setIsCNPJ(true);
                setInscricaoEstadual('123456789');
                setInscricaoMunicipal('987654321');
                setEmail('cliente@exemplo.com');
                setCelular('(11) 91234-5678');
                setTelefone('(11) 3456-7890');
                setDataNascimento('01011990');
                setSexo('Masculino');
                setStatusCliente('Ativo');
                setCep('01001000');
                setLogradouro('Praça da Sé');
                setNumero('123');
                setComplemento('Sala 4');
                setBairro('Sé');
                setCidade('São Paulo');
                setEstado('SP');
            }
        };


        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const handleCpfOuCnpjChange = (e) => {
        const { value } = e.target;
        const sanitizedValue = value.replace(/\D/g, '');

        let valorFormatado = sanitizedValue;

        if (sanitizedValue.length <= 11) {
            valorFormatado = formatadorCPF(sanitizedValue);
            setIsCNPJ(false);
            // Limpar campos específicos de CNPJ quando for CPF
            setRazaoSocial('');
            setInscricaoEstadual('');
            setInscricaoMunicipal('');
        } else if (sanitizedValue.length <= 14) {
            valorFormatado = formatadorCNPJ(sanitizedValue);
            setIsCNPJ(sanitizedValue.length === 14);
        }

        setCpfCnpj(valorFormatado);
    };

    return (
        <section className="container-principal-cadastro-cliente">
            <dialog id="CaixaDeDialogo">
                <div className="conteudo-dialog">
                    <div className="dialog-texto">
                        <p>{texto}</p>
                        <button onClick={fecharModal}>Ok</button>
                    </div>
                </div>
            </dialog>

            <Cabecalho />
            <CookieAceite />
            <main>
                <MenuLateral />
                <section className="conteudo-cadastro-cliente">
                    <div className="titulo-perfil">
                        <h1>
                            <span>Clientes</span> &gt; Cadastro de Cliente
                        </h1>
                    </div>
                    <BtnVoltar />
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'>
                                <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                                <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                                    <animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                                </path>
                            </svg>
                            <h2>Salvando...</h2>
                        </div>
                    ) : (
                    <div className="perfil-cadastro-cliente">
                        <h2>Digite os dados do cliente</h2>
                        <form className="form-cadastro-cliente" onSubmit={enviarCadastroCliente}>
                            <label>Nome/Nome Fantasia: <span className="span-obrigatorio">*</span></label>
                            <div className="input-nome">
                                <input
                                    type="text"
                                    value={nome}
                                    onChange={(e) => setNome(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o nome do cliente"
                                    required
                                />
                            </div>

                            {isCNPJ && (
                                <>
                                    <label>Razão Social:</label>
                                    <div className="input-nome">
                                        <input
                                            type="text"
                                            value={razaoSocial}
                                            onChange={(e) => setRazaoSocial(e.target.value)}
                                            maxLength={255}
                                            placeholder="Digite a razão social (para CNPJ)"
                                        />
                                    </div>
                                </>
                            )}

                            <label>CPF/CNPJ: <span className="span-obrigatorio">*</span></label>
                            <div className="input-CpfOuCnpj">
                                <input
                                    type="text"
                                    value={cpfCnpj}
                                    onChange={handleCpfOuCnpjChange}
                                    placeholder="Digite CPF ou CNPJ"
                                />
                            </div>

                            {isCNPJ && (
                                <>
                                    <label>Inscrição Estadual: <span className="span-obrigatorio">*</span></label>
                                    <div className="input-nome">
                                        <input
                                            type="text"
                                            value={inscricaoEstadual}
                                            onChange={(e) => setInscricaoEstadual(e.target.value)}
                                            maxLength={20}
                                            placeholder="Digite a IE (para CNPJ)"
                                            required
                                        />
                                    </div>

                                    <label>Inscrição Municipal:</label>
                                    <div className="input-nome">
                                        <input
                                            type="text"
                                            value={inscricaoMunicipal}
                                            onChange={(e) => setInscricaoMunicipal(e.target.value)}
                                            maxLength={20}
                                            placeholder="Digite a IM (opcional)"
                                        />
                                    </div>
                                </>
                            )}

                            <label>E-mail: <span className="span-obrigatorio">*</span></label>
                            <div className="input-email">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Digite o e-mail"
                                    required
                                />
                            </div>

                            <label>Celular: <span className="span-obrigatorio">*</span></label>
                            <div className="input-celular">
                                <input
                                    type="text"
                                    value={celular}
                                    onChange={(e) => setCelular(mascaraCelular(e.target.value))}
                                    placeholder="Digite o celular"
                                    maxLength={15}
                                    required
                                />
                            </div>

                            <label>Telefone Fixo:</label>
                            <div className="input-celular">
                                <input
                                    type="text"
                                    value={telefone}
                                    onChange={(e) => setTelefone(mascaraTelefone(e.target.value))}
                                    placeholder="Digite o telefone fixo (opcional)"
                                    maxLength={14}
                                />
                            </div>

                            <label>Data de Nascimento:</label>
                            <div className="input-dataNascimento">
                                <input
                                    type="text"
                                    value={dataNascimento}
                                    onChange={handleDataNascimentoChange}
                                    placeholder="DD/MM/AAAA"
                                    maxLength="10"
                                />
                            </div>

                            <label>Sexo:</label>
                            <div className="input-sexo">
                                <select value={sexo} onChange={(e) => setSexo(e.target.value)} required>
                                    <option value="">Selecione</option>
                                    <option value="Masculino">Masculino</option>
                                    <option value="Feminino">Feminino</option>
                                    <option value="Outro">Outro</option>
                                </select>
                            </div>

                            <label>Tipo de Cliente: <span className="span-obrigatorio">*</span></label>
                            <div className="input-nivelAcesso">
                                <select value={tipoCliente} onChange={(e) => setTipoCliente(e.target.value)} required>
                                    <option value="Atacadista">Atacadista</option>
                                    <option value="Varejista">Varejista</option>
                                </select>
                            </div>

                            <label>Status do Cliente: <span className="span-obrigatorio">*</span></label>
                            <div className="input-nivelAcesso">
                                <select value={statusCliente} onChange={(e) => setStatusCliente(e.target.value)} required>
                                    <option value="Ativo">Ativo</option>
                                    <option value="Inativo">Inativo</option>
                                    <option value="Bloqueado">Bloqueado</option>
                                </select>
                            </div>

                            <div className='linha-1-endereco'>
                                <div className='conteudo-cep'>
                                    <label className='lasbel-cep'>CEP: <span className='span-obrigatorio'>*</span></label>
                                    <div className='input-cep'>
                                        <input
                                            type="text"
                                            value={cep}
                                            onChange={(e) => setCep(mascaraCep(e.target.value))}
                                            onBlur={() => buscarEnderecoPorCep(cep.replace(/\D/g, ''))}
                                            maxLength={9}
                                            placeholder="Digite o CEP"
                                        />
                                    </div>
                                </div>

                                <div className='conteudo-numero'>
                                    <label className='lasbel-numero'>Número: <span className='span-obrigatorio'>*</span></label>
                                    <div className='input-numero'>
                                        <input
                                            type="text"
                                            value={numero}
                                            onChange={(e) => setNumero(e.target.value)}
                                            placeholder="Digite o Nº"
                                        />
                                    </div>
                                </div>
                            </div>

                            <label>Logradouro:</label>
                            <div className='input-logradouro'>
                                <input
                                    type="text"
                                    value={logradouro}
                                    onChange={(e) => setLogradouro(e.target.value)}
                                    placeholder="Logradouro"
                                    disabled
                                />
                            </div>

                            <label>Bairro:</label>
                            <div className='input-bairro'>
                                <input
                                    type="text"
                                    value={bairro}
                                    onChange={(e) => setBairro(e.target.value)}
                                    placeholder="Bairro"
                                    disabled
                                />
                            </div>

                            <div className='linha-5-endereco'>
                                <div className='conteudo-cidade'>
                                    <label className='lasbel-cidade'>Cidade:</label>
                                    <div className='input-cidade'>
                                        <input
                                            type="text"
                                            value={cidade}
                                            onChange={(e) => setCidade(e.target.value)}
                                            placeholder="Cidade"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className='conteudo-estado'>
                                    <label className='label-estado'>Estado:</label>
                                    <div className='input-estado'>
                                        <input
                                            type="text"
                                            value={estado}
                                            onChange={(e) => setEstado(e.target.value)}
                                            maxLength={2}
                                            placeholder="Estado"
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                            <label>Complemento:</label>
                            <div className='input-complemento'>
                                <input
                                    type="text"
                                    value={complemento}
                                    onChange={(e) => setComplemento(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o complemento (Opcional)"
                                />
                            </div>

                            <button className="bnt-cadastro-cliente" onClick={enviarCadastroCliente}>
                                Cadastrar Cliente
                            </button>
                        </form>
                    </div>
                    )}
                </section>
            </main>
            <Rodape />
        </section>
    );
}